import type { RecommendationsFilters } from "@/api/recommendations";
import type { FiltersApiValues } from "@/providers/filter-registry";

export const toRecommendationsFilters = (apiFilters: FiltersApiValues, text: string): RecommendationsFilters => ({
  text: text || undefined,
  minFollowers: apiFilters.minFollowers,
  maxFollowers: apiFilters.maxFollowers,
  minGmv: apiFilters.minGmv,
  maxGmv: apiFilters.maxGmv,
  minLiveGmv: apiFilters.minLiveGmv,
  maxLiveGmv: apiFilters.maxLiveGmv,
  minVideoGmv: apiFilters.minVideoGmv,
  maxVideoGmv: apiFilters.maxVideoGmv,
  minUnitsSold: apiFilters.minUnitsSold,
  maxUnitsSold: apiFilters.maxUnitsSold,
  minRating: apiFilters.minRating,
  maxRating: apiFilters.maxRating,
  maleAudiencePercent: apiFilters.maleAudiencePercent,
  femaleAudiencePercent: apiFilters.femaleAudiencePercent,
  age: apiFilters.age,
  toneAndApproach: apiFilters.toneAndApproach,
  contentFocus: apiFilters.contentFocus,
  productionQuality: apiFilters.productionQuality,
  topSellingCategories: apiFilters.topSellingCategories,
  minTotalLikes: apiFilters.minTotalLikes,
  maxTotalLikes: apiFilters.maxTotalLikes,
  minPostingFrequency: apiFilters.minPostingFrequency,
  maxPostingFrequency: apiFilters.maxPostingFrequency,
  creatorLevel: apiFilters.creatorLevel,
  categoryPro: apiFilters.categoryPro,
  creatorLanguage: apiFilters.creatorLanguage,
  includeTagIds: apiFilters.includeTagIds,
  excludeTagIds: apiFilters.excludeTagIds,
  includeCohortIds: apiFilters.includeCohortIds,
  excludeCohortIds: apiFilters.excludeCohortIds,
  not: apiFilters.not,
});
